module.exports = __webpack_public_path__ + "img/myguard_about_01.45d156ca.jpg";